const API_URL = `${process.env.REACT_APP_URL_API}${process.env.REACT_APP_PATH_USER}`;


export const getUserInfoById = async ({token, id}) => {
    try {
        const response = await fetch(`${API_URL}/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Error al obtener usuario');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}

export const EliminarUsuario = async ({token, id}) => {
    try {
        //console.log(id);
        const url = `${API_URL}/${id}`
        //console.log(url);
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Error al ELIMINAR el usuario');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}